import type { ReactNode } from "react";

interface EmptyStateProps {
  title: string;
  body?: string;
  action?: { label: string; onClick: () => void };
  children?: ReactNode;
}

export function EmptyState({ title, body, action, children }: EmptyStateProps) {
  return (
    <div style={styles.wrap}>
      <span>{body ? `${title} — ${body}` : title}</span>
      {action && (
        <button type="button" onClick={action.onClick} style={styles.action}>
          {action.label}
        </button>
      )}
      {children}
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  wrap: {
    display: "flex",
    alignItems: "baseline",
    gap: 12,
    padding: "16px 0",
    fontSize: 12,
    color: "var(--fg-3)",
    textAlign: "left",
  },
  action: {
    fontSize: 12,
    color: "var(--fg-2)",
    textDecoration: "underline",
    padding: 0,
    border: "none",
    background: "none",
    cursor: "pointer",
    fontFamily: "inherit",
  },
};
